const script = {}
/* custom blocks */
import block0 from "./LoginPage.vue?vue&type=custom&index=0&blockType=html&lang=en"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__